<div class="white-border">
    <div class="rubies-bar flex items-center justify-center float-left relative cursor-pointer" (click)="openDetailsRubies()" >
        <span class="rubies-value">{{rubies}}</span>
        <img src="/assets/img/new-hud/ruby.svg" alt="Rubi" class="absolute z-10 ruby-img">
    </div>
</div>
